import { FormattedMessage } from "react-intl";

export default function SubscribeTextField({
  register,
  name,
  labelId,
  error,
  type = "text",
}) {
  return (
    <div className="form-label row">
      <div className="col-xl-4 col-lg-3">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-xl-8 col-lg-9">
        <div
          className={`form-label-container ${error?.message ? "mb-3" : ""}`}
        >
          <input
            type={type}
            {...register(name)}
            className={`form-control ${error ? "is-invalid px-4" : ""}`}
          />
          <span>*</span>
        </div>
        {error?.message && (
          <div role="alert" className="alert alert-danger py-1">
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
}
